import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const onImageTextInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("on-image-text").default("on-image-text"),
      text: z.string().default("")
    }),
    shouldValidate: node => !!node.validation.correctAnswers.length,
    validate: (node, entry, context) => {
      const isCorrect = node.validation.correctAnswers.some(answer => cleanText(answer, node.validation) === cleanText(entry.text, node.validation));
      if (!isCorrect) {
        return false;
      }

      //
      // NB: In case the current node is part of an answerGroup, then we must
      // ensure that repeats of the same answer is used across entries.
      //
      if (node.validation.answerGroupId) {
        const contestants = context.inputs.filter(it => {
          const entry = onImageTextInput.entry.asTypeSafe(it.entry);
          if (!entry) {
            return false;
          }
          return it.node.id !== node.id && it.node.nodeType === "on-image-text-input" && it.node.validation.answerGroupId === node.validation.answerGroupId;
        });
        const conflictingEntries = contestants.filter(contenstant => cleanText(entry.text, node.validation) === cleanText(contenstant.entry.text, node.validation));
        if (conflictingEntries.length) {
          const lowestConflictingIndex = Math.min(...conflictingEntries.map(it => it.node.index));
          const isFirstInput = lowestConflictingIndex > node.index;
          return isFirstInput;
        }
      }
      return isCorrect;
    },
    parseLegacyDetailItem: (item, context) => {
      if (["WriteAnswers"].includes(context.relatedTask.taskType) && ["OnImage"].includes(context.relatedTask.answerType ?? "") && typeof item === "string") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "on-image-text",
          text: item
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Writeable"),
    correctAnswerGroup: z.string().nullish().default(null),
    correctAnswer: z.union([z.string(), z.array(z.string())]).nullish().default(null).transform(it => {
      if (!it) {
        return null;
      }
      if (Array.isArray(it)) {
        return it;
      } else {
        return [it];
      }
    }),
    caseSensitive: z.boolean().nullish().default(false),
    ignoreWhitespace: z.boolean().nullish().default(false),
    style: z.object({
      extendSizeBy: z.number().default(0)
    }).default({
      extendSizeBy: 0
    }),
    placement: z.object({
      x: z.number(),
      y: z.number()
    })
  }),
  postprocessSchemaInput: (input, context) => {
    return {
      id: `${context.taskId}-${context.index}`,
      index: context.index,
      nodeType: "on-image-text-input",
      placement: input.placement,
      style: input.style,
      validation: {
        answerGroupId: input.correctAnswerGroup,
        caseSensitive: input.caseSensitive,
        ignoreWhitespace: input.ignoreWhitespace,
        correctAnswers: input.correctAnswerGroup ? context.answerGroups[input.correctAnswerGroup] : input.correctAnswer
      }
    };
  },
  cleanText
});
function cleanText(text, options) {
  // Normalize whitespace
  if (!options.ignoreWhitespace) {
    text = String(text).replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
  } else {
    text = String(text).replace(/\s/g, "");
  }

  // Make canse insensitive?
  if (!options.caseSensitive) {
    text = text.toLowerCase();
  }

  // To make sure that validate accepts all variants of apostrophes
  // See https://dev.azure.com/gyldendaldenmark/GU-Produkter/_workitems/edit/93957
  text = text.replace(/[’‛‘´`′‵]/, "'");
  return text;
}

export { onImageTextInput };
//# sourceMappingURL=input.text.js.map
